import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

// pages
import Home from 'pages/home'
import NameForm from 'pages/nameform'
import Result from 'pages/result'
import Exam from 'pages/exam'

export default function Routes() {
  const basename = window.location.host === 'sspai-game.mogita.rocks' ? '/' : '/page/sspai_index'

  return (
    <BrowserRouter basename={basename}>
      <Switch>
        <Route exact path={`/`} component={Home} />
        <Route path={`/name-form`} component={NameForm} />
        <Route path={`/result`} component={Result} />
        <Route path={`/exam`} component={Exam} />
        <Redirect from={`*`} to={`/`} />
      </Switch>
    </BrowserRouter>
  )
}
